<div class="content">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Forbidden</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      {{ email() ? email() : ('ERRORS.403.USER' | translate) }}
      {{ 'ERRORS.403.MESSAGE' | translate }}
    </mat-card-content>
    <mat-card-actions *ngIf="email()">
      <a mat-raised-button color="warn" href="/logout/">Sign out</a>
    </mat-card-actions>
  </mat-card>
</div>
